export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/minusCircleGreyIcon.18704a89.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};